import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HeroImage } from '../data/hero-images';
interface HeroSlideshowProps {
  images: HeroImage[];
  /** ms each slide stays visible before crossfading to the next */
  intervalMs?: number;
  /** ms for the fade transition itself */
  fadeMs?: number;
}
/**
 * Auto-playing crossfade slideshow with no controls.
 * Continuously fades through any number of images.
 * Includes a slow Ken Burns zoom for cinematic feel.
 */
export function HeroSlideshow({
  images,
  intervalMs = 5500,
  fadeMs = 1600
}: HeroSlideshowProps) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (images.length <= 1) return;
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [images.length, intervalMs]);
  // Reset index if image set shrinks
  useEffect(() => {
    if (index >= images.length) setIndex(0);
  }, [images.length, index]);
  if (images.length === 0) {
    return <div className="absolute inset-0 bg-sea-blue" aria-hidden />;
  }
  const current = images[index] ?? images[0];
  const fadeSeconds = fadeMs / 1000;
  return (
    <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden>
      <AnimatePresence mode="sync">
        <motion.div
          key={current.id + '-' + index}
          initial={{
            opacity: 0,
            scale: 1.08
          }}
          animate={{
            opacity: 1,
            scale: 1.15
          }}
          exit={{
            opacity: 0,
            scale: 1.18
          }}
          transition={{
            opacity: {
              duration: fadeSeconds,
              ease: 'easeInOut'
            },
            scale: {
              duration: (intervalMs + fadeMs) / 1000,
              ease: 'linear'
            }
          }}
          className="absolute inset-0">
          
          <img
            src={current.url}
            alt={current.captionEn || ''}
            className="w-full h-full object-cover"
            draggable={false} />
          
        </motion.div>
      </AnimatePresence>

      {/* Overlay scrim for legibility */}
      <div className="absolute inset-0 bg-sea-blue/40 mix-blend-multiply" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-sand" />
    </div>);

}